export type DisposerFunction = () => any;

/**
 * A place to store (and later call) the unlisten functions returned by
 * Firestore's `onSnapshot` method.
 */
export default class DisposerManager {
    private readonly disposers: DisposerFunction[] = [];

    add(...disposers: DisposerFunction[]) {
        this.disposers.push(...disposers);
    }

    clear() {
        const disposers = this.disposers.splice(0);
        for (let i = 0; i < disposers.length; i++) {
            const fn = disposers[i];
            fn();
        }
    }
}
